export const isUndefined = (obj) => typeof obj === 'undefined';
export const isNil = (obj) => isUndefined(obj) || obj === null;
export const isObject = (fn) => !isNil(fn) && typeof fn === 'object';
export const isPlainObject = (fn) => {
    if (!isObject(fn)) {
        return false;
    }
    const proto = Object.getPrototypeOf(fn);
    if (proto === null) {
        return true;
    }
    const ctor = Object.prototype.hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof ctor === 'function' && ctor instanceof ctor && Function.prototype.toString.call(ctor) === Function.prototype.toString.call(Object);
};
export const validatePath = (path) => (path ? (!path.startsWith('/') ? '/' + path : path) : '');
export const isFunction = (fn) => typeof fn === 'function';
export const isString = (fn) => typeof fn === 'string';
export const isConstructor = (fn) => fn === 'constructor';
export const isEmpty = (array) => !(array && array.length > 0);
export const isSymbol = (fn) => typeof fn === 'symbol';
//# sourceMappingURL=shared.utils.js.map